// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__1Q1J9","chart":"chart__DckUs"};


//////////////////
// WEBPACK FOOTER
// ./src/components/HeatmapChart/styles.scss
// module id = 2131
// module chunks = 1